import { render, staticRenderFns } from "./DownlineBilling.vue?vue&type=template&id=8bb256fe&"
import script from "./DownlineBilling.vue?vue&type=script&lang=js&"
export * from "./DownlineBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports